var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_173_22644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1313 18.6199H7.82673C7.34666 18.6199 6.95703 18.2305 6.95703 17.7504C6.95703 17.2703 7.34666 16.8809 7.82673 16.8809H19.1313C19.6114 16.8809 20.0008 17.2703 20.0008 17.7504C20.0008 18.2305 19.6114 18.6199 19.1313 18.6199Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7547 3.0945L15.525 1.8648C14.8677 1.20735 13.7224 1.20831 13.0659 1.8648L11.2676 3.6631L14.9564 7.35189L16.7547 5.55359C17.0833 5.22574 17.2642 4.7893 17.2642 4.32405C17.2642 3.85974 17.0833 3.42314 16.7547 3.0945Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0372 4.89355L1.0751 13.8556C1.01778 13.9121 0.977815 13.9843 0.959504 14.0634L0.0116297 18.0851C-0.0230816 18.2313 0.0211833 18.3861 0.127387 18.4921C0.20907 18.5748 0.320369 18.62 0.434216 18.62C0.467335 18.62 0.50125 18.6165 0.53421 18.6087L4.55611 17.6608C4.63445 17.6426 4.70657 17.6025 4.7639 17.5452L13.7259 8.5833L10.0372 4.89355Z",
    fill: "#B8B8B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_173_22644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.b6f3e9c3a5abd9a09dd02a1b3f0cdcf7.svg";
export { ForwardRef as ReactComponent };